/********************************************************************************
Filename: np-news-detail.js
Created: 29 Sep 2022
Author: Ron Robertson
Description: Displays a single news item
Usage Example:
<np-news-detail></np-news-detail>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
          #newsDetail{
            padding-top:80px;
            margin:0 auto;
            font-size: var(--bodyFontSize);
            font-family: var(--bodyFontFamily);
          }
          p.blockQuote{
            width:50%;
            margin:0 auto;
            text-align: center;
            line-height: 1.2;
          }
          #stats{
            text-align: center;
            margin-bottom: 24px;
          }
          #category{
            display:inline-block;
            color:#41B6E6;
            padding-right:6px;
            font-family: var(--h4FontFamily);
            font-weight:normal;
          }
          #date{
            display:inline-block;
            padding-left:8px;
            border-left:1px solid #7e7e7e;
            color:#7e7e7e;
            font-weight:normal;
          }
          #articleTitle,
          #moreArticlesTitle{
            margin:0 auto 80px;
            font-size:36px;
            font-family:var(--h2FontFamily);
            font-weight:normal;
            text-align: center;
          }
          #moreArticlesTitle{
            margin: 0 auto 50px;
            display:inline-block;
            color:#000000;
            text-decoration: none;
          }
          #contentWrapper{
            line-height:1.5;
            color:#7e7e7e;
          }
          #contentWrapper .imgWrapper{
            display: table;
            margin:0 auto 80px;
            max-width: 996px;
          }
          #contentWrapper .imgWrapper img{
            max-width: 100%;
          }
          #contentWrapper .imgWrapper.withCaption{

          }
          #contentWrapper .imgWrapper.withCaption img{


          }
          figcaption{
            margin: -10px auto 0;
            padding:20px;
            font-size: 14px;
            box-sizing: border-box;
            display: table-caption;
            caption-side: bottom;
            background-color: #f1f1f1;
            text-align: left;

          }
          #contentWrapper p{
            width: calc((var(--col-width) * 8) + (var(--gutter-width) * 9));

            margin:0 auto 80px;
          }
          #contentWrapper p.blockQuote{
            width: calc((var(--col-width) * 4) + (var(--gutter-width) * 5));
            font-size: 24px;
            font-family: var(--h2FontFamily);
          }
          #contentWrapper p.blockQuote b{
            color: #000000;
          }
          #contentWrapper h1,
          #contentWrapper h2,
          #contentWrapper h3,
          #contentWrapper h4,
          #contentWrapper h5,
          #contentWrapper h6{
            margin:0 auto 20px;
          }
          #contentWrapper ul,
          #contentWrapper ol{
            margin:0 auto 80px;
            box-sizing: border-box;
          }
          #contentWrapper ul li,
          #contentWrapper ol li{
            margin-bottom: 20px;
          }
          #contentWrapper a{
            text-decoration: none;
            color: #41B6E6;
            font-family: var(--h2FontFamily);
          }
          #ctaWrapper{
            margin:0 auto;
            text-align:center;

          }
          .embedWrapper{
            text-align: center;
            margin:0 auto 80px;
            width: 100%;
            position: relative;
            display: table;
            max-width: 996px;
          }
          .embedWrapper iframe{
            width: 100%;
            border: 0;
            aspect-ratio: 16 / 9;
          }
          #backButton{
            display: inline-block;
            color:#41b6e6;
            border: 1px solid #41b6e6;
            padding:8px 16px;
            font-size:21px;
            border-radius:8px;
            text-decoration:none;
            margin:0 auto;
            transition: background-color 0.3s ease-in-out;

          }
          #backButton:hover{
            background-color:#41b6e6;
            color:#ffffff;
          }

          #moreArticlesWrapper{
            display:grid;
            grid-template-columns:repeat(3, 315px);
            justify-content: space-between;
            margin:0 auto;
            text-align: left;
          }

          #contentWrapper p,
          #contentWrapper h1,
          #contentWrapper h2,
          #contentWrapper h3,
          #contentWrapper h4,
          #contentWrapper h5,
          #contentWrapper h6,
          #contentWrapper ul,
          #contentWrapper ol,
          #articleTitle,
          #ctaWrapper,
          #ctaWrapper h2,
          #moreArticlesWrapper{
            width: var(--content-width);
          }

          #moreArticlesWrapper{
            grid-template-columns: repeat(1, 1fr);
          }

          #moreArticlesWrapper np-news-summary:nth-child(4){
            display: none;
          }

          @media screen and (min-width: 480px) {

          }

          @media screen and (min-width: 768px) {
            #contentWrapper p,
            #contentWrapper h1,
            #contentWrapper h2,
            #contentWrapper h3,
            #contentWrapper h4,
            #contentWrapper h5,
            #contentWrapper h6,
            #contentWrapper ul,
            #contentWrapper ol,
            #articleTitle{
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 9));
            }
            #ctaWrapper,
            #ctaWrapper h2,
            #moreArticlesWrapper{
              width: var(--content-width);
            }
            .embedWrapper {
            }
            #moreArticlesWrapper{
              grid-template-columns: repeat(2, calc((var(--col-width) * 6) + (var(--gutter-width) * 5)));
            }

            #moreArticlesWrapper np-news-summary:nth-child(4){
              display: block;
            }
            #contentWrapper p.blockQuote{
              width: calc((var(--col-width) * 8) + (var(--gutter-width) * 9));
            }
          }

          @media screen and (min-width: 960px) {
            #contentWrapper p,
            #contentWrapper h1,
            #contentWrapper h2,
            #contentWrapper h3,
            #contentWrapper h4,
            #contentWrapper h5,
            #contentWrapper h6,
            #contentWrapper ul,
            #contentWrapper ol,
            #articleTitle{
              width: calc((var(--col-width) * 8) + (var(--gutter-width) * 9));
            }
            #moreArticlesWrapper{
              grid-template-columns: repeat(3, calc((var(--col-width) * 4) + (var(--gutter-width) * 3)));
            }

            #moreArticlesWrapper np-news-summary:nth-child(4){
              display: none;
            }

            #contentWrapper p.blockQuote{
              width: calc((var(--col-width) * 6) + (var(--gutter-width) * 5));
            }
          }

          @media screen and (min-width: 1200px) {

            #moreArticlesWrapper{
              grid-template-columns: repeat(3, calc((var(--col-width) * 3) + (var(--gutter-width) * 4)));
            }
            #ctaWrapper,
            #ctaWrapper h2,
            #moreArticlesWrapper{
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
            }

            #moreArticlesWrapper np-news-summary:nth-child(4){
              display:none;
            }
          }

          @media screen and (min-width: 1920px) {
            #contentWrapper p,
            #contentWrapper h1,
            #contentWrapper h2,
            #contentWrapper h3,
            #contentWrapper h4,
            #contentWrapper h5,
            #contentWrapper h6,
            #contentWrapper ul,
            #contentWrapper ol,
            #articleTitle{
              width: calc((var(--col-width) * 6) + (var(--gutter-width) * 5));
            }
            #moreArticlesWrapper{
              grid-template-columns: repeat(4, calc((var(--col-width) * 2) + (var(--gutter-width) * 3)));
            }
            #ctaWrapper,
            #ctaWrapper h2,
            #moreArticlesWrapper{
              width: calc((var(--col-width) * 10) + (var(--gutter-width) * 11));
            }

            #moreArticlesWrapper np-news-summary:nth-child(4){
              display: block;
            }

          }

        </style>

        <div id="newsDetail">
          <div id="stats">
            <div id="category"></div>
            <div id="date"></div>
          </div><!--END stats-->
          <h2 id="articleTitle"></h2>
          <div id="contentWrapper">
            Loading Content...
          </div><!--END contentWrapper-->
          <div id="ctaWrapper">
            <a href='' router-link="/news" id="moreArticlesTitle"></a>
            <div id="moreArticlesWrapper"></div>
            <a href="" id="backButton" router-link="/news">View More News</a>
          </div><!--END ctaWrapper-->
        </div><!--END newsDetail-->
    `;

    class NpNewsDetail extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.fetchSingleData = this.fetchSingleData.bind(this);
            this.fetchMultipleData = this.fetchMultipleData.bind(this);
            this.populateArticleDetails = this.populateArticleDetails.bind(this);
            this.populateArticleContent = this.populateArticleContent.bind(this);
            this.updateMetaData = this.updateMetaData.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.newsDetail = this.shadowRoot.getElementById("newsDetail");
            this.articleTitleEle = this.shadowRoot.getElementById("articleTitle");
            this.categoryEle = this.shadowRoot.getElementById("category");
            this.dateEle = this.shadowRoot.getElementById("date");
            this.contentWrapperEle = this.shadowRoot.getElementById("contentWrapper");
            this.backButtonEle = this.shadowRoot.getElementById("backButton");
            this.moreArticlesTitleEle = this.shadowRoot.getElementById("moreArticlesTitle");
            this.moreArticlesWrapperEle = this.shadowRoot.getElementById("moreArticlesWrapper");

            this.articleId;
            this.articleData={};
            this.moreArticlesData=[];
            this.monthArray=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];


            this.apiUrl = window.location.origin + "/newadminapi/"
            if( window.location.origin.indexOf( "localdev") >= 0 ){
                this.apiUrl = "https://dev4.naturalpoint.private/newadminapi/";
            }

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('article')) {
                this.setAttribute('article', "");
            }
            if (!this.hasAttribute('article-id')) {
              this.setAttribute('article-id', "");
            }

            /* Set Event Listeners */
            this.backButtonEle.addEventListener('click', this.onRouterLinkClick);
            this.moreArticlesTitleEle.addEventListener('click', this.onRouterLinkClick);


        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */

        static get observedAttributes() {
            return ['article-id', 'article'];
        }


      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'article-id') {
          if(newValue != "" && this.article != ""){
            this.fetchSingleData(this.apiUrl + 'articles/'+newValue);
          }else{
            this.populateArticleDetails();
            this.populateArticleContent();
          }
        }

       }/* END attributesChangedCallback */

      /* Getting attributes */
      get article() {
        return this.getAttribute('article');
      }
      get articleId() {
        return this.getAttribute('article-id');
      }


      /* Settinng attributes */
      set article(newValue) {
        this.setAttribute('article', newValue);
      }
      set articleId(newValue) {
        this.setAttribute('article-id', newValue);
      }

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.backButtonEle.removeEventListener('click', this.onRouterLinkClick);
        this.moreArticlesTitleEle.removeEventListener('click', this.onRouterLinkClick);

      }

        /* Method */
        //retreives data for displaying a single article
        fetchSingleData(dataUrl) {
          //get data for view
          if(dataUrl){
              fetch(dataUrl)
              .then(response => response.json())
              .then(data => {
                  if(data.id){
                    //console.log('data found');
                    this.articleData = data;
                    this.populateArticleDetails();
                    this.populateArticleContent();
                    this.updateMetaData();
                  }else{
                    //article not found
                    //console.log('data not found');
                    this.contentWrapperEle.innerHTML = "Article Not Found";
                  }
              })
              .catch(error => {
                //console.log(error);
                this.contentWrapperEle.innerHTML = "Article Not Found";
              });
          }

        }

        //retreives data for displaying multiple articles
        fetchMultipleData(dataUrl) {

          //get data for view
          if(dataUrl){
              fetch(dataUrl)
              .then(response => response.json())
              .then(data => {
                  this.moreArticlesData = data;
                  this.populateMoreArticles(data);
              });
          }
        }

        populateArticleDetails() {
          //title
          if(this.articleData.title){
            this.articleTitleEle.innerHTML = this.articleData.title;
          }else{
            this.articleTitleEle.innerHTML = "";
          }

          //category
          if(this.articleData.category){
            this.categoryEle.innerHTML = this.articleData.category;
          }else{
            this.categoryEle.innerHTML = "";
          }

          //date
          if(this.articleData.date){
            let newValue = this.articleData.date;
            let dateObj = new Date(newValue+"T00:00:00");
            let month = this.monthArray[parseInt(dateObj.getMonth())]
            let year = dateObj.getFullYear();
            this.dateEle.innerHTML = month + " " + year;
          }else{
            this.dateEle.innerHTML = "";
          }

        }

        populateArticleContent() {
          if(this.articleData.page){
            if(this.articleData.page.length > 0){

              //Parse JSON string into JSON object
              this.articleData.page = JSON.parse(this.articleData.page);

              //Clear old content
              this.contentWrapperEle.innerHTML = "";

              //sort blocks by order

              //loop through the sections of the article
              this.articleData.page.forEach((block) => {
                if(block.type == 'image'){
                  let imgWrapper = document.createElement("div");
                  imgWrapper.classList.add('imgWrapper');
                  let newImage = document.createElement("img");
                  newImage.setAttribute('src',block.data.file.url);
                  imgWrapper.appendChild(newImage);

                  // image caption
                  if(block.data.caption){
                    imgWrapper.classList.add('withCaption');
                    let newCaption = document.createElement("figcaption");
                    newCaption.innerHTML = block.data.caption;
                    imgWrapper.appendChild(newCaption);
                  }

                  this.contentWrapperEle.appendChild(imgWrapper);

                }else if(block.type == 'paragraph'){

                  let newParagraph = document.createElement("p");
                  newParagraph.innerHTML = block.data.text;
                  this.contentWrapperEle.appendChild(newParagraph);

                }else if(block.type == 'header'){
                  let newHeading;
                  if(block.data.level == 2){
                    newHeading = document.createElement("h2");
                  }else if(block.data.level == 3){
                    newHeading = document.createElement("h3");
                  }else if(block.data.level == 4){
                    newHeading = document.createElement("h4");
                  }else if(block.data.level == 5){
                    newHeading = document.createElement("h5");
                  }else if(block.data.level == 6){
                    newHeading = document.createElement("h6");
                  }else{
                    newHeading = document.createElement("h1");
                  }

                  newHeading.innerHTML = block.data.text;
                  this.contentWrapperEle.appendChild(newHeading);

                }else if(block.type == 'embed'){

                  let newEmbedWrapper = document.createElement('div');
                  newEmbedWrapper.classList.add('embedWrapper');

                  let newEmbed = document.createElement("iframe");
                  newEmbedWrapper.appendChild(newEmbed);

                  newEmbed.setAttribute('src', block.data.embed);
                  newEmbed.setAttribute('title','Embedded Video');
                  newEmbed.setAttribute('frameborder','0');
                  newEmbed.setAttribute('allowfullscreen','')

                  // embed caption
                  if(block.data.caption){
                    newEmbedWrapper.classList.add('withCaption');
                    let newCaption = document.createElement("figcaption");
                    newCaption.innerHTML = block.data.caption;
                    newEmbedWrapper.appendChild(newCaption);
                  }

                  this.contentWrapperEle.appendChild(newEmbedWrapper);


                }else if(block.type == 'list'){
                  let newList;
                  if(block.data.style == 'unordered'){
                    newList = document.createElement("ul");
                  }else if(block.data.style == 'ordered'){
                    newList = document.createElement("ol");
                  }

                  if(block.data.items.length > 0){

                    block.data.items.forEach((item) => {
                      let newItem = document.createElement("li");
                      newItem.innerHTML = item;
                      newList.appendChild(newItem);
                    });
                  }
                  this.contentWrapperEle.appendChild(newList);
                }else if(block.type == 'quote') {
                  let newBlockQuote = document.createElement("p");
                  newBlockQuote.classList.add('blockQuote');
                  newBlockQuote.innerHTML = block.data.text;
                  this.contentWrapperEle.appendChild(newBlockQuote);
                }

              });

            }
          }else{
            this.contentWrapperEle.innerHTML = "";
          }
          //populate the More Articles section
          //this.fetchMultipleData('/news/articles.json');
          this.fetchMultipleData(this.apiUrl + 'articles');
        }

        populateMoreArticles(data) {
          if(data.length > 0){

            //order by date
            data.sort(this.sortByDate);

            //clear out previous content
            this.moreArticlesWrapperEle.innerHTML = "";

            //keeps track of the number of more articles placed
            let articleCount = 0;

            // If there are more articles to display
            if(data.length > 0) {
              this.moreArticlesTitleEle.innerHTML = "OptiTrack News";
            }

            for(let i=0; i < data.length; i++) {

              let article = data[i];

              //makes sure the same article is not displayed
              if(article.id != this.articleId){

                let newsSummary = document.createElement("np-news-summary");
                newsSummary.setAttribute('title', article.title);
                newsSummary.setAttribute('category', article.category);
                newsSummary.setAttribute('date', article.date);
                newsSummary.setAttribute('img', article.img);
                newsSummary.setAttribute('router-link', "/news/"+article.id+"/"+article.title.replaceAll(' ', '-'));
                newsSummary.addEventListener('click', this.onRouterLinkClick);

                this.moreArticlesWrapperEle.appendChild(newsSummary);
                articleCount++;
              }

              // only display 4 articles
              if(articleCount >= 4){

                return;
              }
            };
          }
        }
        updateMetaData() {
          console.log('updateMetaData called');
          // General Meta Data
          document
            .querySelector('title')
            .innerHTML = 'OptiTrack News';
          document
            .querySelector('meta[name="description"]')
            .setAttribute('content', this.articleData.title);

          // Facebook Meta Data
          document
            .querySelector('meta[property="og:title"]')
            .setAttribute('content','OptiTrack News');
          document
            .querySelector('meta[property="og:description"]')
            .setAttribute('content', this.articleData.title);
            document
            .querySelector('meta[property="og:url"]')
            .setAttribute('content', window.location.href);
            document
            .querySelector('meta[property="og:image"]')
            .setAttribute('content', this.articleData.img);

            // Twitter Meta Data
            document
            .querySelector('meta[property="twitter:url"]')
            .setAttribute('content',window.location.href);
            document
            .querySelector('meta[property="twitter:title"]')
            .setAttribute('content', 'OptiTrack News');
            document
            .querySelector('meta[property="twitter:description"]')
            .setAttribute('content', this.articleData.title);
            document
            .querySelector('meta[property="twitter:card"]')
            .setAttribute('content', 'summary_large_image');
            document
            .querySelector('meta[property="twitter:image"]')
            .setAttribute('content', this.articleData.img);

        }

        //Sorts the array of objects by the date
        sortByDate(a, b) {
          if(a.date > b.date) {
            return -1;
          }
          if(a.date < b.date){
            return 1;
          }
          return 0;
        }

        //dispatches the event so other components can listen for it
        onRouterLinkClick(event) {
          event.preventDefault();
          // Dispatch the event
          this.dispatchEvent(new CustomEvent('routerLinkClick',{bubbles:true,composed:true,detail:{'url':event.target.getAttribute('router-link')}}));
        }



    } /* END class */

    window.customElements.define('np-news-detail', NpNewsDetail);

  })();
